<template>
    <v-dialog v-model="dialogStatusModel" kind="modal" status="default" class="application-dialog">
        <div slot="title">
            登录新管理员QQ
        </div>
    <!-- <v-panel
        v-model="dialogStatusModel"
        :mask-closable="false"
        :width="672"
        :min-height="483"
        :max-height="483"
        title="登录新管理员QQ"
        @hide="dialogStatusModel = false"
> -->
        <div class="ptlogin" style="margin-bottom: 20px;">
            <iframe width="100%" height="100%" frameborder="0" scrolling="no" :src="loginUrl" style="width: 417px; height: 376px; visibility: visible;" />
        </div>
    </v-dialog>
</template>

<script>
import ptConfig from '@/config/ptConfig';
export default {
    props: {
        main: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            loginUrl: '',
            dialogStatusModel: false,
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        /**
         * 获取qq登录相关url参数
         * @return {string}
         */
        getPtUrl() {
            const protocol = location.protocol || 'https:';
            const host = location.host || location.hostname;
            const LOCATION_ORIGIN = `${protocol}//${host}`;
            const CGI_MB_VERIFY_RET = `${LOCATION_ORIGIN}/cl/GroupApply/MbaCall`;
            const proxyUrl = encodeURIComponent(`${protocol}//${host}/static_proxy/qidian/src/comp/login/proxy.html`);
            return  `https://xui.ptlogin2.qq.com/cgi-bin/xlogin?cb=JSON_CB_20150313&appid=1600001230&s_url=${CGI_MB_VERIFY_RET}&style=&proxy_url=${proxyUrl}&border_radius=1&enable_qlogin=0&hide_close_icon=1&target=self&regmaster=&t=${+new Date()}`;
        },

        /**
         * qq登录相关
         * @return {void}
         */
        getPtUrlCopyFromLbf() {
            const protocol = location.protocol || 'https';
                const host = location.host || location.hostname;
                const isLocal = host.slice(0, 6) == 'local.';
                const localDir = !isLocal ? '' : 'page/';
                const hideCloseIcon = 1;
                const regmaster = '';
                const styleType = '';
                const miBaoCgiNew = `${protocol}//${host}/${localDir}mng/account/contacts/verifyContactNewQQ${!isLocal ? '' : '.html'}`;
                const QQLoginForGetNewQQNum = `${'https://xui.ptlogin2.qq.com/cgi-bin/xlogin?cb=JSON_CB_20150313&'
                    + '&appid='}${ptConfig.appid_qq
                    }&s_url=${miBaoCgiNew
                    }&style=${styleType
                    }&proxy_url=${ptConfig.proxyUrl
                    }&border_radius=1&enable_qlogin=0&`
                    + `hide_close_icon=${hideCloseIcon
                    }&target=self&`
                    + `regmaster=${regmaster}`;
            this.loginUrl = QQLoginForGetNewQQNum;
        },

        /**
         * 获取新的QQ号
         * @param {string} result QQ号
         * @return {void}
         */
        getNewQQNum(result) {
            if (result.r === 0) {
                if (result.newQQ === this.main.contactAdminQQ) {
                    this.$message.error('管理员QQ不能相同');
                    this.$parent.getNewQQFrom('');
                    this.qqLoginFrameSwitch(false);
                    return;
                }
                this.$message.success('新QQ号验证成功');
                this.$parent.getNewQQFrom(result.newQQ);
                this.qqLoginFrameSwitch(false);
            } else {
                if (result.errMsg) {
                    this.$message.error(result.errMsg);
                } else {
                    this.$message.error('新QQ号验证失败');
                }
                this.$parent.getNewQQFrom('');
                this.qqLoginFrameSwitch(false);
                return;
            }
        },

        /**
         * qq登录框控制开关
         * @param {boolean} status 开关状态
         * @return {void}
         */
        qqLoginFrameSwitch(status) {
            this.dialogStatusModel = status;
        },
        init() {
            this.getPtUrlCopyFromLbf();
            window.veri_newQQ_success = (result) => {
                this.getNewQQNum(result);
            };
        },
    },

};
</script>

<style>
.ptlogin body .login .header .close{
    display: none;
}
</style>
